var map = {
	"./ME-CREPE.svg": 6282,
	"./arrow-down.svg": 2058,
	"./arrow-left.svg": 6962,
	"./arrow-right.svg": 9872,
	"./blackball.svg": 8247,
	"./blinking-logo.svg": 9542,
	"./boaboy.svg": 8826,
	"./captainsboil.svg": 4778,
	"./checked.svg": 5386,
	"./close.svg": 1509,
	"./cocoru.svg": 7951,
	"./coming-soon.svg": 9803,
	"./digital-1.svg": 8344,
	"./digital-2.svg": 5580,
	"./dish-list.svg": 8366,
	"./download.svg": 2718,
	"./face-1.svg": 5228,
	"./face-2.svg": 8119,
	"./face-3.svg": 8887,
	"./face-4.svg": 547,
	"./ginger.svg": 1008,
	"./group.svg": 5422,
	"./haidilao-hotpot.svg": 8300,
	"./home-step-1.svg": 9840,
	"./home-step-2.svg": 314,
	"./home-step-3.svg": 8569,
	"./ins.svg": 2205,
	"./jimichi.svg": 6084,
	"./kaori-izakaya.svg": 1401,
	"./kokoro.svg": 3646,
	"./logo.svg": 5621,
	"./lost.svg": 3192,
	"./minus.svg": 496,
	"./miss-fu.svg": 8411,
	"./office-hours-mobile.svg": 5083,
	"./office-hours.svg": 3478,
	"./order.svg": 7729,
	"./phone.svg": 8213,
	"./planet.svg": 304,
	"./plus.svg": 9481,
	"./proposal.svg": 2284,
	"./scan.svg": 5426,
	"./scroll-icon.svg": 5282,
	"./startup.svg": 9930,
	"./store.svg": 8196,
	"./sushi-shogun.svg": 4057,
	"./tsukiji.svg": 6424,
	"./zomi-footer.svg": 8167,
	"./zomi.svg": 9978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7314;